import EnrollmentLegal from '../domain/EnrollmentLegal';
import EnrollmentPage from '../domain/EnrollmentPage';
import HomePage from '../domain/HomePage';
import InitPage from '../domain/InitPage';
import TrackingPage from '../domain/TrackingPage';
import EvaluationPage from '../domain/EvaluationPage';
import AuthorizeMailPage from '../domain/AuthorizeMailPage';

const routes = [
  {
    path: '/enrolamiento',
    component: InitPage,
    exact: true,
    title: 'Inicio',
    isPublic: true,
    restricted: true,
  },
  {
    path: '/enrolamiento/inicio',
    component: HomePage,
    exact: true,
    title: 'Acceso',
    isPublic: true,
    restricted: true,
  },
  {
    path: '/enrolamiento/formulario/juridico',
    component: EnrollmentLegal,
    exact: true,
    title: 'Enrolamiento Persona Jurídica',
    isPublic: true,
    restricted: true,
  },
  {
    path: '/enrolamiento/formulario',
    component: EnrollmentPage,
    exact: true,
    title: 'Enrolamiento',
  },
  {
    path: '/enrolamiento/seguimiento',
    component: TrackingPage,
    exact: true,
    title: 'Seguimiento',
    isPublic: true,
  },
  {
    path: '/enrolamiento/evaluacion',
    component: EvaluationPage,
    exact: true,
    title: 'evaluacion',
    isPublic: true,
  },
  {
    path: '/autorizar-declarante',
    component: AuthorizeMailPage,
    exact: true,
    title: 'Autorizar declarante',
    isPublic: true,
  },
];

export default routes;
